import { nativeCall } from './common'
/**
 * 返回上一页
 */
export const goBack = () => {
  nativeCall('back')
}
/**
 * 是否登录
 */
export const isLogin = (cb) => {
  return nativeCall('isLogin', null, cb)
}
/**
 * 获取用户信息
 * token
 * data:{
    token:当前用户token
   },
 */
export const getUserInfo = (cb) => {
  return nativeCall('getUserInfo', null, cb)
}
/**
 * 跳转补登页面
 */
export const fillLogin = (data, cb) => {
  return nativeCall('fillLogin', data, cb)
}
/**
 * 跳转帮助与反馈页面
 */
export const feedBack = (data, cb) => {
  return nativeCall('feedBack', data, cb)
}
/**
 * 跳转补缴页面
 */
export const repairPayment = (data, cb) => {
  return nativeCall('repairPayment', data, cb)
}
/**
 * 跳转app登录页面
 */
export const login = (data, cb) => {
  return nativeCall('login')
}
/**
 * appf分享
 */
export const invokeShareView = (data, cb) => {
  return nativeCall('invokeShareView', data, cb)
}
// 跳转去乘车
export const goRiding = (data, cb) => {
  return nativeCall('goRiding', data, cb)
}
//获取状态栏高度
export const getStatusHeight = (cb) => {
  return nativeCall('statusHeight', null, cb)
}
/**
 * 选择站点信息
 */
export const chooseStation = (cb) => {
  return nativeCall('chooseStation', null, cb)
}
/**
 * 客服弹框
 */
export const callHotLine = (cb) => {
  return nativeCall('callHotLine', null, cb)
}
/**
 * 客服打电话
 */
export const callServicePhone = (data, cb) => {
  return nativeCall('callServicePhone', data, cb)
}
/**
 * 跳转外部浏览器 {urlString：'' }
 */
export const browserOpenURL = (data, cb) => {
  return nativeCall('browserOpenURL', data, cb)
}
/**
 * 去首页 {urlString：'' }
 */
export const goHomePage = (data, cb) => {
  return nativeCall('goHome', data, cb)
}

/**
 * 跳转去任何页面 {path: }
 */
export const jumpAppPageWithRouteURL = (data, cb) => {
  return nativeCall('jumpAppPageWithRouteURL', data, cb)
}


// 去购票详情
export const jumpToAnswerTicketDetail = (data, cb) => {
  return nativeCall('jumpToAnswerTicketDetail', data, cb)
}
